import GoogleMap from 'google-map-react';
import React, { Dispatch, SetStateAction } from 'react';
import {
  BROOKLYN_CENTER,
  BROOKLYN_MARKERS,
  MANHATTAN_CENTER,
  MANHATTAN_MARKERS,
  QUEENS_CENTER,
  QUEENS_MARKERS,
} from '../../constants/location';

const centerMap = {
  manhattan: MANHATTAN_CENTER,
  brooklyn: BROOKLYN_CENTER,
  queens: QUEENS_CENTER,
};

const markersMap = {
  manhattan: MANHATTAN_MARKERS,
  brooklyn: BROOKLYN_MARKERS,
  queens: QUEENS_MARKERS,
};

export interface NeighborhoodsProps {
  city: string;
}

function Neighborhoods(props: NeighborhoodsProps) {
  const [zoom, setZoom] = React.useState(12);

  const [selected, setSelected] = React.useState(null);

  return (
    <section className="how_it_works container">
      <h2 className="headline-2 w-100 center">
        Neighborhoods we clean in {props.city}
      </h2>
      <div
        className="container"
        style={{
          height: '600px',
          width: '100%',
          margin: '5rem auto -5rem',
          borderRadius: 32,
        }}
      >
        <GoogleMap
          defaultCenter={centerMap[props.city.toLowerCase()]}
          bootstrapURLKeys={{
            key: 'AIzaSyC6sIeOixSRTUa4uBLG0bl8u4m_NPm4ckg',
          }}
          defaultZoom={12}
          onChange={({ zoom }) => setZoom(zoom)}
        >
          {markersMap[props.city.toLowerCase()].map((marker) => (
            <Marker
              key={marker.place}
              lat={marker.lat}
              lng={marker.lng}
              text={marker.place}
              zoom={zoom}
              selected={selected}
              setSelected={setSelected as any}
            />
          ))}
        </GoogleMap>
      </div>
    </section>
  );
}

interface MarkerProps {
  text: string;
  lat: number;
  lng: number;
  zoom: number;
  selected: string | null;
  setSelected: (text: string) => void;
}

function Marker({ text, ...rest }: MarkerProps) {
  const scale = Math.pow(2, rest.zoom / 18);

  return (
    <div title={text}>
      <img
        src={require('../../assets/icons/Location.svg').default}
        alt="location marker icon"
        style={{ transform: `scale(${scale})` }}
        onClick={() => rest.setSelected(text)}
        onMouseOver={() => rest.setSelected(text)}
      />
      {rest.selected === text && (
        <div
          style={{
            position: 'absolute',
            top: -10,
            left: 0,
            width: 'auto',
            height: 'auto',
            minWidth: '100px',
            backgroundColor: 'white',
            borderRadius: 8,
            fontSize: 14,
            fontWeight: 600,
            fontFamily: 'Poppins, sans-serif',
            padding: 8,
            zIndex: 100,
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
}

export default Neighborhoods;
